import axios from "axios";
import axiosInstance from "../utils/axiosConfig";

// Create an axios instance with default configurations
const apiClient = axios.create({
  // baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  baseURL: process.env.REACT_APP_API_URL || "https://home-dentist-new-server-0oyw.onrender.com/api",
  timeout: 10000, // 10 seconds timeout
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

// Interceptor for request logging (optional but helpful for debugging)
apiClient.interceptors.request.use(
  (config) => {
    console.log("API Request:", {
      method: config.method,
      url: config.url,
      data: config.data,
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor for response logging
apiClient.interceptors.response.use(
  (response) => {
    console.log("API Response:", {
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error) => {
    console.error("API Error:", {
      message: error.message,
      response: error.response ? error.response.data : null,
    });
    return Promise.reject(error);
  }
);

export const productService = {
  getAllProducts: async () => {
    try {
      const response = await axiosInstance.get("/products");
      console.log("Products fetched:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching products:", {
        message: error.message,
        response: error.response,
        request: error.request,
      });

      if (error.response) {
        throw new Error(
          error.response.data.message ||
          `Server error: ${error.response.status}`
        );
      } else if (error.request) {
        // The request was made but no response was received
        throw new Error("No response received from server");
      } else {
        // Something happened in setting up the request that triggered an Error
        throw new Error("Error setting up the request");
      }
    }
  },

  searchByImage: async (imageFile) => {
    try {
      const formData = new FormData();
      formData.append('image', imageFile);

      const response = await axiosInstance.post('/products/search-by-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data.products;
    } catch (error) {
      console.error('Image Search Error:', error);
      throw error;
    }
  }

};

export default productService;
